import api from './api';
import type { ApiResponse } from './api';

export interface AccountInfo {
  id: number;
  username: string;
  email: string;
  role: 'admin' | 'user';
  expires_at: string | null;
  language: string;
  created_at: string;
  last_login_at: string | null;
  setup_completed: number;
  setupCompleted: boolean;
  subscriptionStatus: 'active' | 'expiring_soon' | 'expired' | 'unlimited';
  daysRemaining: number | null;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const accountService = {
  async getMe(): Promise<AccountInfo> {
    const response = await api.get<ApiResponse<AccountInfo>>('/account/me');
    return response.data.data;
  },

  async changePassword(data: ChangePasswordRequest): Promise<void> {
    await api.post('/account/change-password', data);
  },

  async completeSetup(): Promise<void> {
    await api.post('/account/complete-setup');
  },
};
